import { __decorate } from "tslib";
import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { ComponentService } from '../../services/component.service';
import { DepositOriginService } from '../../services/deposit-origin.service';
import { depositOriginLoginRoute, depositOriginState } from '../../services/deposit-origin';
import { ResetPasswordComponent } from '../reset-password';
import { DomSanitizer } from '@angular/platform-browser';
import { WebsiteThemeService } from '../../services/website-theme.service';
import { WebClientService } from '../../services/webclient-settings.service';
import { GoogleAnalyticsService } from '../../services/google-analytics.service';
import { load } from 'recaptcha-v3';
import { WalletInvitationModalComponent } from '../wallet/wallet-invitation-modal/wallet-invitation-modal.component';
import { UpdateUserDataModalComponent } from '../update-user-data-modal/update-user-data-modal.component';
import { DocumentExpirationModalComponent } from '../documentation/document-expiration-modal/document-expiration-modal.component';
import { EmailGoogleRegistrationComponent } from "../register/email-google-registration/email-google-registration.component";
import { KycReassessmentComponent } from "../kyc-reassessment/kyc-reassessment.component";
// the answers of the code step that have their own message in the template
const MFA_STEP_ANSWERS = ['MFA_CODE_NOT_VALID', 'MFA_NOT_AVAILABLE', 'USER_ACCOUNT_HAS_BEEN_LOCKED'];
/**
 * Login Component
 */
let LoginComponent = class LoginComponent {
    constructor(httpClient, router, auth, compService, sanitizer, themeService, webSettingsService, googleAnalyticsService, route, changeDetectorRef, depositOriginService) {
        this.httpClient = httpClient;
        this.router = router;
        this.auth = auth;
        this.compService = compService;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.webSettingsService = webSettingsService;
        this.googleAnalyticsService = googleAnalyticsService;
        this.route = route;
        this.changeDetectorRef = changeDetectorRef;
        this.depositOriginService = depositOriginService;
        this.showActivationMessage = false;
        // TODO: this label is mispelled. This should be fixed here, as
        // well as everywhere it is used and migration file in API should be created
        // to fix the key name in language_values table!
        this.statusActivateMessage = "SUCCESSUFULLY_ACTIVATED";
        this.user = {};
        this.isAuth = false;
        this.isError = false;
        this.dataObject = {};
        this.secondColor = '';
        this.errorColor = '';
        this.inputBackColor = '';
        this.inputTextColor = '';
        this.textColor = '';
        this.successColor = '';
        this.logo = '';
        this.mainColor = '';
        this.guestIsOn = false;
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.loginError = '';
        this.attemptsLeft = 0;
        this.mfaStep = false;
        // the account has to set a new password before it can be used again (the API mailed the link)
        this.passwordChangeRequired = false;
        this.mfaProviderLogin = false;
        // the API's key for the code step, issued once the credentials were accepted
        this.mfaToken = null;
        this.disableButton = false;
        this.submitted = false;
        this.showPassword = false;
        this.user_document_verification_upload = false;
        this.userData = {};
        // where close() takes the user after login when a branch decided it ('/' otherwise)
        this.afterLoginRoute = null;
        this.themeService.getTheme().subscribe((data) => {
            this.guestIsOn = this.webSettingsService.applySettings('GUEST_USER.ON');
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.inputTextColor = this.themeService.getStyleAttribute('input_text_color');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.logo = this.themeService.getStyleAttribute('logo_image');
            if (this.logo === '' || this.logo === ' ' || this.logo === null) {
                this.logo = 'assets/img/logo-not-found.png';
            }
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
        });
        const location = window.location;
        this.baseUrl = `${location.protocol}//${location.host}`;
    }
    setRecaptchaToken() {
        load(localStorage.getItem('recaptcha_site_key')).then((recaptcha) => {
            recaptcha.execute('submit').then((token) => {
                this.user.recaptchaToken = token;
            });
        });
    }
    ;
    ngOnDestroy() {
        this.clearRecaptchaRefreshInterval();
    }
    initRecaptchaRefreshInterval() {
        let loginComponent = this;
        this.recaptchaRefreshInterval = setInterval(function () { loginComponent.setRecaptchaToken(); }, 2 * 60 * 1000);
    }
    clearRecaptchaRefreshInterval() {
        if (this.recaptchaRefreshInterval != null) {
            clearInterval(this.recaptchaRefreshInterval);
            this.recaptchaRefreshInterval = null;
        }
    }
    performUnlockIpAction() {
        let hash = this.route.snapshot.queryParamMap.get('hash');
        let ip = this.route.snapshot.queryParamMap.get('ip');
        let user_id = this.route.snapshot.queryParamMap.get('user_id');
        let device_identifier = this.getDeviceIdentifier();
        if (hash != null && ip != null && user_id != null) {
            this.httpClient.post('unlockip', {
                'hash': hash,
                'ip': ip,
                'user_id': user_id,
                'device_identifier': device_identifier
            }).subscribe(response => console.log(response));
        }
    }
    ngOnInit() {
        let action = this.route.snapshot.queryParamMap.get('action');
        if (action != null) {
            if (action == "unlockip") {
                this.performUnlockIpAction();
            }
        }
        this.setRecaptchaToken();
        this.initRecaptchaRefreshInterval();
    }
    generateRandomString() {
        let length = Math.floor(Math.random() * 20) + 60;
        let result = '';
        for (let i = 0; i < length; i++) {
            result += String.fromCharCode(Math.floor(Math.random() * 94) + 33);
        }
        return result;
    }
    getDeviceIdentifier() {
        if (localStorage.getItem('deviceIdentifier') === null) {
            let deviceIdentifier = this.generateRandomString();
            localStorage.setItem('deviceIdentifier', deviceIdentifier);
            return deviceIdentifier;
        }
        else {
            return localStorage.getItem('deviceIdentifier');
        }
    }
    submit(providerLogin = false) {
        this.submitted = true;
        this.isError = false;
        this.attemptsLeft = 0;
        this.user.client_id = 1;
        this.user.user_agent = navigator.userAgent;
        this.user.device_identifier = this.getDeviceIdentifier();
        if (providerLogin) {
            this.user.credential = this.providerToken;
            this.user.provider = this.provider;
        }
        else {
            delete this.user.credential;
        }
        if (!this.mfaStep) {
            delete this.user.mfa_code;
        }
        // With the token of the first answer the code goes alone to login/mfa: the credentials
        // are not sent again, so an Apple login needs no second confirmation. An API that
        // issues no token gets the same login again with the code.
        const withToken = this.mfaStep && !!this.mfaToken;
        const request = withToken
            ? this.httpClient.post('login/mfa', { mfa_token: this.mfaToken, mfa_code: this.user.mfa_code })
            : this.httpClient.post('login', this.user);
        request.subscribe((result) => {
            this.setRecaptchaToken();
            this.isAuth = true;
            this.dataObject = result;
            this.auth.setLoggedIn(true);
            this.auth.setToken(this.dataObject.auth_token, this.dataObject.token_duration);
            localStorage.setItem('refresh_token', this.dataObject.refresh_token);
            if (localStorage.getItem('wallet_info_modal_viewed')) {
                localStorage.removeItem('wallet_info_modal_viewed');
            }
            if (localStorage.getItem('auth_token')) {
                this.auth.fetchUser().then((result) => {
                    var _a;
                    localStorage.setItem("defaultCurrency", this.webSettingsService.getWebSetting('DEFAULT_CURRENCY'));
                    localStorage.setItem('allowedDecimalPlaces', this.webSettingsService.getWebSetting('WALLET.NUMBER_OF_DECIMALS_BUY_SELL'));
                    var region = this.webSettingsService.getWebSetting('APP_REGION');
                    this.personallyValidated = JSON.parse(localStorage.getItem('user')).personally_validated;
                    this.docmentationVerified = (_a = JSON.parse(localStorage.getItem('user')).company) === null || _a === void 0 ? void 0 : _a.verified;
                    this.isCompanyUser = JSON.parse(localStorage.getItem('user')).is_company_user;
                    this.walletCreated = JSON.parse(localStorage.getItem('user')).wallet_created;
                    this.showWalletMessage = JSON.parse(localStorage.getItem('user')).user_settings.show_wallet_message;
                    this.eligibleForWallet = JSON.parse(localStorage.getItem('user')).eligible_for_wallet;
                    this.newDataPopulated = JSON.parse(localStorage.getItem('user')).newDataPopulated;
                    this.eataandpoaosPopulated = JSON.parse(localStorage.getItem('user')).eataandpoaosPopulated;
                    this.kycReassessmentRequired = JSON.parse(localStorage.getItem('user')).kyc_reassessment_required;
                    this.kycReassessmentDataSubmitted = JSON.parse(localStorage.getItem('user')).kyc_reassessment_data_submitted;
                    this.updateUserDataMessageShownOnLogin = JSON.parse(localStorage.getItem('user')).user_settings.update_user_data_message_shown_on_login;
                    this.updateUserDataPoaoMessageShownOnLogin = JSON.parse(localStorage.getItem('user')).user_settings.update_user_data_poao_message_shown_on_login;
                    this.notifyUserOnDocumentExpiration = JSON.parse(localStorage.getItem('user')).notify_user_on_expired_document;
                    this.personalDocumentExpired = JSON.parse(localStorage.getItem('user')).personal_document_expired;
                    this.personalDocumentNotExists = JSON.parse(localStorage.getItem('user')).personal_document_not_exist;
                    this.verificationDocumentsExpired =
                        JSON.parse(localStorage.getItem('user')).verification_documents_expired === true;
                    this.verifyPageShownOnLogin = JSON.parse(localStorage.getItem('user')).user_settings.verify_page_shown_on_login;
                    this.userData = JSON.parse(localStorage.getItem('user'));
                    this.user_document_verification_upload = this.userData.user_document_verification_upload == '1';
                    if (JSON.parse(localStorage.getItem('user')).wallet_blocked) {
                        localStorage.setItem('ResetMfaMessageModalComponentShownOnStart', '0');
                    }
                    var check_status_verbose_id = JSON.parse(localStorage.getItem('user')).user_settings.check_status_verbose_id;
                    if (check_status_verbose_id == 'KYC_RESIDENT_CHECK_FAILD_NOT_EU' || check_status_verbose_id == 'KYC_ADDITIONAL_DOCUMENTATION') {
                        this.router.navigateByUrl('/kycdocumentation');
                    }
                    else if (check_status_verbose_id == 'KYC_RESIDENT_CHECK_FAILD') {
                        this.router.navigateByUrl('/kycquestionnaire');
                    }
                    else if (((this.isCompanyUser == false && (!this.personallyValidated || (region == 'EU' && !this.userData.proof_of_address_submitted))) ||
                        (this.isCompanyUser == true && !this.personallyValidated && !this.docmentationVerified)) && this.verifyPageShownOnLogin) {
                        this.router.navigateByUrl('/verify');
                    }
                    else if (this.isCompanyUser == true && this.personallyValidated && !this.docmentationVerified && this.verifyPageShownOnLogin) {
                        this.router.navigateByUrl('/verify');
                    }
                    else if (this.webSettingsService.getWebSetting('DEFAULT_ROUTE') !== '') {
                        this.router.navigateByUrl(this.webSettingsService.getWebSetting('DEFAULT_ROUTE'));
                    }
                    if (this.kycReassessmentRequired || this.kycReassessmentDataSubmitted) {
                        this.compService.openModal(KycReassessmentComponent, {
                            user: JSON.parse(localStorage.getItem('user'))
                        });
                    }
                    else if (this.verificationDocumentsExpired) {
                        // Verification refused because the documents were read too long ago: restart from the verify page
                        this.router.navigateByUrl('/verify');
                        this.compService.openModal(DocumentExpirationModalComponent, { context: 'verification-deadline' });
                    }
                    else if (depositOriginState(this.userData) !== null) {
                        // the deposit trigger wants the statement or the proof of origin: its window in the wallet
                        // for a user with one, on the exchange home page otherwise
                        this.afterLoginRoute = depositOriginLoginRoute(this.userData);
                        this.router.navigateByUrl(this.afterLoginRoute);
                        this.depositOriginService.open(depositOriginState(this.userData));
                    }
                    else if (((!this.eataandpoaosPopulated && !this.updateUserDataPoaoMessageShownOnLogin) || (!this.newDataPopulated && !this.updateUserDataMessageShownOnLogin)) && region != 'EU') {
                        this.router.navigateByUrl('/');
                        this.compService.openModal(UpdateUserDataModalComponent, { context: 'login' });
                    }
                    else if (this.notifyUserOnDocumentExpiration == true && (this.personalDocumentNotExists == true || this.personalDocumentExpired == true)) {
                        this.router.navigateByUrl('/');
                        this.compService.openModal(DocumentExpirationModalComponent);
                    }
                    else if (this.walletCreated == false && this.showWalletMessage == true && this.eligibleForWallet == true) {
                        this.router.navigateByUrl('/');
                        this.compService.openModal(WalletInvitationModalComponent);
                    }
                    else if (this.compService.componentRef.instance.success) {
                        this.router.navigateByUrl(this.compService.componentRef.instance.success);
                    }
                    else {
                        this.router.navigateByUrl('/');
                    }
                    if (JSON.parse(localStorage.getItem('user'))) {
                        let array = [];
                        array.push({
                            'event': 'loggedIn',
                            userId: JSON.parse(localStorage.getItem('user')).id
                        });
                        this.googleAnalyticsService.pushGAEvents(array);
                    }
                }).then((result) => {
                    this.close();
                }).catch((error) => {
                    this.close();
                });
            }
            else {
                this.close();
            }
        }, (error) => {
            this.submitted = false;
            this.setRecaptchaToken();
            this.loginError = error.error['message'];
            if (this.loginError === 'PASSWORD_CHANGE_REQUIRED') {
                // The password (or the Google/Apple account) was accepted, but the account was
                // flagged to set a new password first and the API mailed the link for it: the
                // notice takes the place of the form, with or without the MFA step reached.
                this.passwordChangeRequired = true;
                this.mfaStep = false;
                this.mfaToken = null;
                delete this.user.mfa_code;
                return;
            }
            if (this.loginError === 'USER_HAS_MFA_ENABLED') {
                // The password (or the Google/Apple account) was accepted and the account has
                // MFA on: ask for the code and send it with the token of this answer.
                this.mfaStep = true;
                this.mfaProviderLogin = providerLogin;
                this.mfaToken = error.error['mfa_token'] || null;
                this.user.mfa_code = '';
                return;
            }
            if (this.loginError === 'MFA_TOKEN_NOT_VALID') {
                // the key expired or was used: back to the login form, with a message
                this.mfaStep = false;
                this.mfaToken = null;
                delete this.user.mfa_code;
            }
            this.isError = true;
            if (typeof error.error['attempts_left'] !== 'undefined') {
                this.attemptsLeft = error.error['attempts_left'];
            }
        });
    }
    submitMfa() {
        // An empty field is answered as a wrong code: no request, and no Apple window
        if (String(this.user.mfa_code || '').trim() === '') {
            this.isError = true;
            this.loginError = 'MFA_CODE_NOT_VALID';
            this.attemptsLeft = 0;
            return;
        }
        if (!this.mfaToken && this.mfaProviderLogin && this.provider === 'apple') {
            // Without a token the login is repeated, and an Apple authorization code is
            // single-use and the first login spent it, so the repeat asks Apple for a fresh one.
            AppleID.auth.signIn().then(response => {
                this.providerToken = response.authorization.code;
                this.submit(true);
            }).catch(() => {
                // the Apple window was closed or refused: the step stays, with a message
                this.isError = true;
                this.loginError = 'APPLE_SIGN_IN_FAILED';
            });
            return;
        }
        this.submit(this.mfaProviderLogin);
    }
    // Any other refusal in the code step (429 TOO_MANY_LOGIN_ATTEMPTS, BAD_TOKEN_CREDENTIALS,
    // a cancelled Apple confirmation) gets one message instead of none.
    mfaStepFailed() {
        return this.mfaStep && this.isError && MFA_STEP_ANSWERS.indexOf(this.loginError) === -1;
    }
    keyEnter(event) {
        if (event.keyCode === 13) {
            this.submit();
        }
    }
    dontHave() {
        this.modal.destroy();
        this.compService.openModal(EmailGoogleRegistrationComponent);
    }
    openReset() {
        this.modal.destroy();
        this.compService.openModal(ResetPasswordComponent);
    }
    // "Send a new link" on the new-password notice: the forgotten-password window, with the
    // e-mail of the login filled in when the login was by e-mail (empty for a username, and for
    // a Google/Apple account whatever the login field holds).
    sendNewPasswordLink() {
        const email = this.user.credential ? null : this.loginEmail();
        this.modal.destroy();
        this.compService.openModal(ResetPasswordComponent, email ? { email } : undefined);
    }
    // "OK" on the new-password notice: back to the empty login form
    dismissPasswordChangeRequired() {
        this.passwordChangeRequired = false;
        this.loginError = '';
        this.isError = false;
        this.user.password = '';
    }
    loginEmail() {
        const username = String(this.user.username || '').trim();
        return username.indexOf('@') !== -1 ? username : null;
    }
    close() {
        document.body.className = '';
        if (((this.isCompanyUser == false && !this.personallyValidated) ||
            (this.isCompanyUser == true && !this.personallyValidated && !this.docmentationVerified)) && this.verifyPageShownOnLogin) {
            this.router.navigateByUrl('/verify');
        }
        else {
            this.router.navigateByUrl(this.afterLoginRoute || '/');
        }
        this.modal.destroy();
    }
    togglePassword(event) {
        this.showPassword = !this.showPassword;
        event.preventDefault();
    }
    ngAfterViewInit() {
        this.initializeGoogleSignIn();
        this.initializeAppleSingIn();
    }
    initializeGoogleSignIn() {
        google.accounts.id.initialize({
            client_id: localStorage.getItem('google_client_id'),
            callback: (response) => this.googleLoginCallback(response),
            ux_mode: 'popup',
            context: 'singin',
        });
        this.googleButtonWrapper = this.renderGoogleSingInButton();
    }
    googleLoginCallback(response) {
        this.providerToken = response.credential;
        this.provider = 'google';
        this.submit(true);
    }
    renderGoogleSingInButton() {
        const googleLoginWrapper = document.querySelector('#google-btn-login');
        google.accounts.id.renderButton(googleLoginWrapper, {
            type: 'icon',
            width: '200',
        });
        const googleLoginWrapperButton = googleLoginWrapper.querySelector('div[role=button]');
        return {
            click: () => {
                googleLoginWrapperButton.click();
            },
        };
    }
    handleGoogleSingIn() {
        this.googleButtonWrapper.click();
    }
    initializeAppleSingIn() {
        AppleID.auth.init({
            clientId: localStorage.getItem('apple_service_id'),
            scope: 'name email',
            usePopup: true,
            redirectURI: `${this.baseUrl}`,
        });
    }
    handleAppleSignIn() {
        AppleID.auth.signIn().then(response => {
            this.providerToken = response.authorization.code;
            this.provider = 'apple';
            this.submit(true);
        });
    }
};
LoginComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: Router },
    { type: AuthService },
    { type: ComponentService },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: WebClientService },
    { type: GoogleAnalyticsService },
    { type: ActivatedRoute },
    { type: ChangeDetectorRef },
    { type: DepositOriginService }
];
__decorate([
    Input()
], LoginComponent.prototype, "showActivationMessage", void 0);
__decorate([
    Input()
], LoginComponent.prototype, "statusActivateMessage", void 0);
LoginComponent = __decorate([
    Component({
        selector: 'ecd-login',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./login.component.html")).default
    })
], LoginComponent);
export { LoginComponent };
